import React, { Fragment } from 'react'

const Spinner = ({ isLoading, message }) => (
    <Fragment>
        { isLoading &&
            <div className="page-loader">
            <div className="container">
                <div className="spinner" />
                <div className="message">{message}</div>
            </div>
        </div> }
    </Fragment>
);

export { Spinner }
